export function usePageAltTransition(globalStore) {
    const { $gsap: gsap } = useNuxtApp();
    const {
        clearPrecover,
        applyCoveredState,
        resetScrollUnderCover,
        prefersReducedMotion,
        getEls,
        isCovered
    } = useCoverNavigation();

    let enterTl = null;
    let leaveDone = null;
    let enterDone = null;

    const finishEnter = (done) => {
        enterDone = null;
        enterTl = null;
        globalStore.setPageTransitionComplete(true);
        document.body.dataset.scrollDirection = 'init';
        document.body.dataset.scrolled = 'false';
        document.body.classList.remove('is-loading');
        document.body.classList.remove('hide-pointer-events');
        done();
    };

    const finishLeave = (done) => {
        leaveDone = null;
        globalStore.setPageTransitionComplete(false);
        globalStore.setToggleMobileMenu(false);
        globalStore.setWizard(false);
        done();
    };

    // Kill in-flight tweens and unblock Vue's transition lifecycle
    const killTimelines = () => {
        enterTl?.kill();
        enterTl = null;

        if (leaveDone) {
            finishLeave(leaveDone);
        }

        // Unblock a cancelled enter without clearing leave loading state
        if (enterDone) {
            const done = enterDone;
            enterDone = null;
            done();
        }
    };

    return {
        name: 'page-transition',
        mode: 'out-in',
        css: false,

        onBeforeEnter: () => {
            globalStore.setPageTransitionBeforeComplete(true);

            // Lock top curve as the trailing edge while the curtain exits upward
            const { shapeTopEl, shapeBottomEl } = getEls();
            if (shapeTopEl) gsap.set(shapeTopEl, { scaleY: 1 });
            if (shapeBottomEl) gsap.set(shapeBottomEl, { scaleY: 0 });
        },

        onEnter: (el, done) => {
            killTimelines();
            enterDone = done;
            // Allow a new cover if the user navigates during enter
            clearPrecover();

            const { screenEl, shapeTopEl } = getEls();

            if (!screenEl || prefersReducedMotion()) {
                if (screenEl) {
                    gsap.set(screenEl, { autoAlpha: 0, yPercent: -100 });
                    if (shapeTopEl) gsap.set(shapeTopEl, { scaleY: 0 });
                }
                finishEnter(done);
                return;
            }

            enterTl = gsap
                .timeline({
                    paused: true,
                    onComplete: () => finishEnter(done)
                })
                .to(screenEl, {
                    duration: 0.58,
                    yPercent: -100,
                    ease: 'power2.out'
                })
                .to(
                    screenEl,
                    {
                        duration: 0.28,
                        autoAlpha: 0,
                        ease: 'power1.out'
                    },
                    '-=0.3'
                )
                .set(shapeTopEl, { scaleY: 0 })
                .play();
        },

        onBeforeLeave: () => {
            globalStore.setPageTransitionBeforeComplete(false);
            document.body.classList.add('is-loading');
            document.body.classList.add('hide-pointer-events');

            // Edge case: leave without beforeEach cover (e.g. noCover) — snap opaque
            if (!isCovered.value) {
                applyCoveredState();
            }
        },

        onLeave: (el, done) => {
            killTimelines();
            leaveDone = done;

            if (!isCovered.value) {
                applyCoveredState();
            }

            resetScrollUnderCover();
            finishLeave(done);
        }
    };
}
